export default __webpack_public_path__ + "static/funnel-significance-light-3216ec96fafb6ad8a6eab35172a9b1da.png";